export class SliderSettings {
  constructor(overrides) {
    const defaults = {
      leftText: 'CONSENT',
      rightText: 'LEGITIMATE INTEREST',
      backgroundColor: '#d8d9dd',
      activeBackgroundColor: '#777a7e',
      magnifyingGlassBackgroundColor: '#777a7e',
      magnifyingGlassColor: '#ffffff',
      font: {
        fontSize: 14,
        fontWeight: '400',
        color: '#000000',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      activeFont: {
        fontSize: 14,
        fontWeight: '400',
        color: '#ffffff',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      languages: {}
    };
    Object.assign(this, defaults, overrides);
  }
}
export const SliderTypes = {
  text: {
    leftText: {
      title: 'Consent Text',
      type: 'InputLanguage'
    },
    rightText: {
      title: 'Legit. Interest Text',
      type: 'InputLanguage'
    }
  },
  styles: {
    backgroundColor: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    activeBackgroundColor: {
      title: 'Active Background Color',
      type: 'ColorPicker'
    },
    magnifyingGlassColor: {
      title: 'Search Button Color',
      type: 'ColorPicker'
    },
    magnifyingGlassBackgroundColor: {
      title: 'Search Button Background Color',
      type: 'ColorPicker'
    },
    font: {
      title: 'Font',
      type: 'Font'
    },
    activeFont: {
      title: 'Active Font',
      type: 'Font'
    }
  }
};